module.exports = __webpack_public_path__ + "img/ic_hj_mode_relas.f019468b.png";